/* global DateTimeHelperMomentAdapter, DateTimeHelper */

'use strict';

/**
 * Helper: Date Format
 *
 * @version 12.4.0 #756 MLIBJS-121 Add validation to export wdDateTimeHelper for ES6 usage
 *          7.10.0 #522 Add time conversion functionality
 *
 * @author Ryan Sweeney <rsweeney@webduct.com>
 * @author Dallas Vogels <dvogels@webduct.com>
 * @author Erik Orozco <eorozco@intersog.com> 
 *
 * @copyright (c) 2016-2020 Build Centrix
 */

var wdDateTimeHelper = angular.module('wd.helper.dateTime', [])
    .factory(
        'wdDateTimeHelper',
        [
            'moment',

            function (moment) {
                var shortEnglishHumanizer = humanizeDuration.humanizer({
                    language: 'short_en',
                    languages: {
                        short_en: {
                            y: function () {
                                return 'y'
                            },
                            mo: function () {
                                return 'mo'
                            },
                            w: function () {
                                return 'w'
                            },
                            d: function () {
                                return 'd'
                            },
                            h: function () {
                                return 'h'
                            },
                            m: function () {
                                return 'm'
                            },
                            s: function () {
                                return 's'
                            },
                            ms: function () {
                                return 'ms'
                            },
                            decimal: function () {
                                return '.'
                            }
                        }
                    },
                    spacer: '',
                    delimiter: ' '
                });

                var dateTimeHelperHumanizeDurationAdapter = new HumanizeDurationMomentAdapter(shortEnglishHumanizer);
                var dateTimeHelperMomentAdapter = new DateTimeHelperMomentAdapter(moment, dateTimeHelperHumanizeDurationAdapter);

                return new DateTimeHelper(dateTimeHelperMomentAdapter);

            }
        ]
    );
if (typeof module !== 'undefined' && module.exports) {
    module.exports = wdDateTimeHelper;
} 
// EOF
